module.exports = __webpack_public_path__ + "img/Annoyed_Option_7.e73250c8.jpg";